import React from "react";
import Footer from "../component/Footer";
import Navbar from "../component/Navbar";
import Profile from "../component/user/profile";

const User = () => {
  return (
    <div>
      <Navbar />
      <Profile />
      <Footer />
    </div>
  );
};

export default User;
